<div class="question-type__text">
  <h1 class="fs__xxl">File Upload</h1>
  <p class="fs__md">Allows participants to upload files (e.g., documents, images) as part of their response. Useful for collecting supporting materials.</p>
  <ul class="question-type__bullet-points">
    <li class="fs__sm">
      <span class="sub-text">You can select a minumum and maximum number of images that can be uploaded.</span>
    </li>
    <li class="fs__sm">
      <span class="sub-text"
        >You can specify a maximum size of file that can be uploaded. Be careful not to allow too many large files as this may consume your storage
        allocation.</span
      >
    </li>
    <li class="fs__sm">
      <span class="sub-text">Images can be PNG or JPG format</span>
    </li>
  </ul>
  <h2 class="fs__lg">Example</h2>
  <p class="fs__md">Please upload any images that you have taken during your task.</p>
</div>
